import { createActions } from 'redux-actions';

export const { loadDeleteAccount, loadedDeleteAccount, errorDeleteAccount } = createActions(
  'LOAD_DELETE_ACCOUNT',
  'LOADED_DELETE_ACCOUNT',
  'ERROR_DELETE_ACCOUNT',
);
